import { IShortVideoItem } from '../../../types'
import {
  EpisodeListItemDescription,
  EpisodeListItemDetailsWrap,
  EpisodeListItemTitle,
  EpisodeListItemWrap,
} from './EpisodeListItem.style'
import { ShortVideoItemThumbnailComp } from './ShortVideoItemThumbnailComp'
import Link from '../../../components/Link/Link'

export const ShortVideoListItem = ({
  data,
}: {
  data: IShortVideoItem
  isLast: boolean
}) => {
  return (
    <Link href={data.link}>
      <EpisodeListItemWrap>
        <ShortVideoItemThumbnailComp
          name={data.title}
          imageObj={data?.imageObj}
        />
        <EpisodeListItemDetailsWrap itemProp={data.secondaryTitle}>
          <EpisodeListItemTitle>{data.title}</EpisodeListItemTitle>
          {data.secondaryTitle && (
            <EpisodeListItemDescription>
              {data.secondaryTitle}
            </EpisodeListItemDescription>
          )}
        </EpisodeListItemDetailsWrap>
      </EpisodeListItemWrap>
    </Link>
  )
}
